import React from 'react';
import { withTranslation } from 'react-i18next';
import GoalServices from '../../../../services/goal.services';
import PermissionComp from './permission.component';
import { reactLoader, removeReactLoader, constructNestedKRPayload } from '../../../../utils/common.js';
import DeleteCommonModal from '../../../deleteCommonModal.component';
import KrAlignDependance from './krAlignDependence';
import HelpTextComp from '../../../helper/helptext.component';
import NestedInlineComp from './NestedInline.component';
import AddKrTag from '../../../../krTags/components/addkrTag.component'
import  RetainUpdateModal  from '../../../retainUpdateModal.component';
import {KeyDownEvent} from '../../../../utils/eventKey'
import { ThemeProvider, Checkbox, Textfield, RadioGroup, Radio, IconButton, Dropdown } from '@workboard/wobo-ui';
import CloseIcon from '@material-ui/icons/Close'
import styled from 'styled-components';
import {getTargetValue} from '../../../common/getTargetValue.component'
import Customokr from './../../../custom_fields/customobj/Customokr';
import { ErrorTextComp } from "../../../inputs/fields.component";
import KrRelationshipWrapper from './krRelationshipWrapper';
import KrMilestonesSection from './KrMilestonesSection';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { krdetailConstants } from '../../../../constants/krdetails.constants';

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledCommittedCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
  .MuiFormControlLabel-label {
    margin-left: 0
  }
  legend {
    color: #333943
  }
`

const StyledTextfield = styled(Textfield)`
  .MuiInputLabel-asterisk {
    margin-left: -3px !important;
  }

  .MuiInputLabel-formControl {
    font-size: 13px !important;
    margin-bottom: 4px !important;
    margin-top: 4px;
  }
`;

const StyledRadioGroup = styled(RadioGroup)`
  .Mui-checked svg {
    color: rgb(0, 114, 171) !important;
  }
  .MuiRadio-root {
    padding: 0;
    width: 24px;
    height: 24px;
  }
  label {
    height: 24px;
  }
  input[type="radio"] {
    visibility: initial !important;
  }
  .Mui-focusVisible {
    outline: 2px solid #007fad !important;
    border-radius: 0;

    &:focus {
      outline: 2px solid #007fad !important;
    }
  }
`;
const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 39px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #cal-overall-dropdown{
    min-width: 226px;
  }
  #result-value-dropdown{
    min-width: 220px;
  }
`;

const MIT_DS_METRICS = ['1', '2', '3', '4',"8","9", 1, 2, 3, 4, 8, 9];
class DataStreamComp extends React.Component {
  constructor(props) {
    super(props);
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    this.state = {
      dsCatList: null,
      dsListSel: this.props.item ? this.props.item.selectedDs : [],
      dsSelPage: this.props.item && this.props.item.selectedDs ? false : true,
      addEditFlag: this.props.addEditFlag,
      confirmPopup: false,
      externalSrc:false,
      titleRetain: "",
      contentRetain: "",
      selectedTypeOpt:'',
      dataStream: {},
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : []
    };
    this.addDsToList = this.addDsToList.bind(this);
    this.showDsKr = this.showDsKr.bind(this);
    this.removeObjFromList = this.removeObjFromList.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.changeRadioOpt = this.changeRadioOpt.bind(this);
    this.updateTags = this.updateTags.bind(this);
  }

  removeObjFromList() {
    this.setState({
      dsListSel: [],
      dsSelPage: true
    });
  }

  addDsToList(ds) {
    if(this.props.lastType != this.props.krType
      && this.props.lastType !== 'krstudio' // no alert when going from krstudio to person, ww-11221
      && (this.props.lastType == 'kpi' || this.props.lastType == 'person')
      && this.props.addEditFlag){
      this.setState({
        externalSrc: true,
        titleRetain: "",
        contentRetain: "",
        dataStream: ds
      })
    }else if (this.state.addEditFlag) {
      this.setState({
        externalSrc: true,
        dataStream: ds
      });
    }
    else {
      this.setState({
        dsListSel: [ds]
      });
      this.showDsKr();
    }
  }

  showDsKr() {
    this.setState({
      dsSelPage: false
    });
  }

  exitDeleteModal() {
    this.setState({
      confirmPopup: false,
      externalSrc:false
    });
  }

  saveItems() {
    this.setState({
      confirmPopup: false,
      externalSrc:false,
      dsListSel: [this.state.dataStream]
    });
    this.showDsKr();
  }
  changeRadioOpt(value) {
		const valueToSet = value
		this.setState(
		  {
        selectedTypeOpt: valueToSet
		  }
		)
	}
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }
  render() {
    const { t } = this.props
    return (
      <div className="dataStreams">
        {this.state.dsSelPage == true ? (
          <DsSelectionComp
            addDsToList={this.addDsToList}
            showDsKr={this.showDsKr}
            dsListSel={this.state.dsListSel}
            selectedTypeOpt={this.state.selectedTypeOpt}
            {...this.props}
          />
        ) : (
          <DsKrComp
            dsListSel={this.state.dsListSel}
            selectedTypeOpt={this.state.selectedTypeOpt}
            {...this.props}
            removeObjFromList={this.removeObjFromList}
          />
        )}

        {this.state.confirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t(`Save Key Result with New Datastream`)}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t('Are you sure you want to save this key result with datastream you selected? This will get rid of past key result data.')}
            buttonText={t("Save")}
          />
        )}

        {
          this.state.externalSrc  &&
            <RetainUpdateModal
                  selectedType={this.state.selectedTypeOpt}
                  changeRadio={this.changeRadioOpt}
                  exitDeleteModal={this.exitDeleteModal}
                  deleteItems={this.saveItems}
                  titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
                  contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
                />
        }
      </div>
    );
  }
}

class DsSelectionComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErr: false,
      catListFiltered: [],
      dsCatListFull: [],
      confirmPopup: false,
      externalSrc:false,
      titleRetain: "",
      contentRetain: "",
      selectedTypeOpt:this.props.selectedTypeOpt ? this.props.selectedTypeOpt : '',
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[]
    };
    this.validateDsKr = this.validateDsKr.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
    this.filterCatList = this.filterCatList.bind(this);
    this.loadDataStreamList = this.loadDataStreamList.bind(this);
    this.addDsToListInt = this.addDsToListInt.bind(this);
    this.GoalServices = new GoalServices();
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.changeRadioOpt = this.changeRadioOpt.bind(this);
    this.updateTags = this.updateTags.bind(this);
  }
  componentWillUnmount() {
		this.props.kpiRef(null)
	}

  componentDidMount() {
    this.props.kpiRef(this)
    this.dataStreamSearch.focus();
    this.loadDataStreamList();
  }

  loadDataStreamList() {
    let _this = this;
    reactLoader(true);
    this.GoalServices.getDataStreamList().then(response => {
      removeReactLoader();
      if (response.data) {
        _this.setState({
          dsCatListFull: response.data,
          catListFiltered: response.data
        });
      }
    });
  }

  handleCancel(){
    this.props.closeKrRightPane(false,this.props.item.id ? this.props.item.id : '')
  }

  validateDsKr() {
    if(this.props.lastType != this.props.kpiType
      && this.props.lastType !== 'krstudio' // no alert when going from krstudio to person, ww-11221
      && (this.props.lastType == 'kpi' || this.props.lastType == 'person')
      && this.props.addEditFlag){
      this.setState({
        externalSrc: true,
        titleRetain: "",
        contentRetain: "",
      })
    }
    if (
      this.props.lastType != this.props.kpiType &&
      this.props.addEditFlag &&
      this.props.dsListSel &&
      Object.keys(this.props.dsListSel).length > 0
    ) {
      this.setState({
        confirmPopup: true
      });
    } else {
      if (
        this.props.dsListSel &&
        Object.keys(this.props.dsListSel).length > 0
      ) {
        this.props.showDsKr();
      } else {
        this.setState({
          showErr: true
        });
        $('.krRightPaneContent').parent().animate({
          scrollTop: $(".krRightPaneContent")[0].scrollHeight - 100
        });
      }
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false, externalSrc:false });
  }

  saveItems() {
    if (this.props.dsListSel && Object.keys(this.props.dsListSel).length > 0) {
      this.props.showDsKr();
    } else {
      this.setState({
        showErr: true
      });
      $('.krRightPaneContent').parent().animate({
        scrollTop: $(".krRightPaneContent")[0].scrollHeight - 100
      });
    }
  }

  changeRadioOpt(value) {
		const valueToSet = value
		this.setState(
		  {
        selectedTypeOpt: valueToSet
		  }
		)
	}

  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }

  filterCatList(e) {
    let term = e.target.value.trim().toLowerCase();
    if (term.length > 0) {
      let updatedList = [];
      this.state.dsCatListFull.map(function (item) {
        let itemName = item.name;
        if (
          itemName
            .trim()
            .toLowerCase()
            .indexOf(term) > -1
        ) {
          updatedList.push(item);
        } else {
          let temp = Object.assign({}, temp, item);
          temp.streams = item.streams.filter(function (item1) {
            let itemName = item1.name;
            if (
              itemName
                .trim()
                .toLowerCase()
                .indexOf(term) > -1
            ) {
              return true;
            } else {
              return false;
            }
          });
          if (temp.streams.length > 0) {
            updatedList.push(temp);
          }
        }
      });

      this.setState({
        catListFiltered: updatedList
      });
    } else {
      this.setState({
        catListFiltered: this.state.dsCatListFull
      });
    }
  }

  addDsToListInt(ds) {
    this.props.addDsToList(ds);
    this.setState({
      showErr: false
    });
  }

  render() {
    let dsCatList = this.state.catListFiltered;
    const { t } = this.props;
    return (
      <div>
        <div className="dataStreamHeading">
          <div className="dsTextLabel">
            {t('Search and select a data stream')}
            <span className="text-style-1">*</span>
          </div>
          <div className="datastreamSearchDiv">
            <div className="spriteSearchImg" />
            <input
              type="text"
              className="datastreamSearchInp"
              ref={node => (this.dataStreamSearch = node)}
              placeholder={t("Search for a data stream or category")}
              onKeyUp={event => this.filterCatList(event)}
              autoComplete="off"
            />
          </div>
        </div>

        {dsCatList && dsCatList.length > 0 && (
          <div className="catDsList" data-testid="catDsList">
            {dsCatList.map((item, index) => (
              <CatListing catList={item} addDsToList={this.addDsToListInt} key={index} />
            ))}
          </div>
        )}
        {this.state.showErr && (
          <div className="errorTxt">{t('Select a data stream')}</div>
        )}
        {this.state.confirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t("Save Key Result with New Data Type")}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t("Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.")}
            buttonText={t("Save")}
          />
        )}
        {
          this.state.externalSrc  &&
            <RetainUpdateModal
                  selectedType={this.state.selectedTypeOpt}
                  changeRadio={this.changeRadioOpt}
                  exitDeleteModal={this.exitDeleteModal}
                  deleteItems={this.saveItems}
                  titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
                  contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
                />
        }
      </div>
    );
  }
}

class CatListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDsList: true,
      confirmPopup: false,
      externalSrc:false,
      titleRetain: "",
      contentRetain: "",
      selectedTypeOpt:'',
    };
    this.showHideDsList = this.showHideDsList.bind(this);
  }

  showHideDsList(e, act) {
    e.preventDefault();
    this.setState({
      showDsList: act
    });
  }

  render() {
    let item = this.props.catList;
    const {showDsList} = this.state;
    return (
      <div className="catDs">
        <div
          className="dsTextLabel catHeading"
          onClick={(e) => this.showHideDsList(e, !showDsList)}
          onKeyDown={e => KeyDownEvent(e,
            () => {this.showHideDsList(e, !showDsList)}
          )}
          tabIndex={0}
          role="button"
          aria-expanded={showDsList}
          data-testid="select-datastream"
        >
          <div
            className={
              showDsList
                ? "show-CatUp icon icon-dropdown-14px catUpArrow"
                : "show-CatDown icon icon-dropdown-14px catDownArrow"
            }
          ></div>
          {item.name}
        </div>
        <ul>
          {showDsList &&
            item.streams &&
            item.streams.length > 0 &&
            item.streams.map((ds, dsInd) => (
              <li
                className="dsList dsRadioDiv"
                data-testid="dsList dsRadioDiv"
                key={ds.id}
                id={"ds_" + ds.id}
                tabIndex="0"
                role="button"
                onClick={() => this.props.addDsToList(ds)}
                onKeyDown={e => KeyDownEvent(e,
                  () => {this.props.addDsToList(ds)}
                )}
              >
                <DsComp ds={ds} />
              </li>
          ))}
        </ul>
      </div>
    );
  }
}

const DsComp = ({
  ds,
  showCancel = false,
  removeObjFromList = null
} = props) => {
  return (
    <div className="ds">
      <div className="dsNameDiv">
        <div className="dsName">{ds.name}</div>
        {showCancel && (
          <IconButton
            className="spriteCancelImg"
            aria-label={"Unselect datastream " + ds.name}
            onClick={removeObjFromList}
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>
      <div className="dsDet dsTextLabel">
        <div className="dsDet1">
          Frequency | {ds.frequency_text} <span className="dotClass"></span>{" "}
          Type | {ds.data_type_text}{" "}
          {ds.last_data_value != null && ds.last_data_value ? (
            <span>
              <span className="dotClass"></span> Last Value |{" "}
              {ds.last_data_value}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="dsDet2">
          {ds.last_data_at_format_1 != "" &&
            "Last Update | " + ds.last_data_at_format_2}
        </div>
      </div>
    </div>
  );
};

class DsKrComp extends React.Component {
  constructor(props) {
    super(props);
    let isStretchEnabled = this.props.addOkrData.isStretchEnabled ?? this.props.goalDetails.isStretchEnabled ?? false;
    let committedKRFlag = isStretchEnabled && this.props.item && parseInt(this.props.item.committed_target) ? parseInt(this.props.item.committed_target) : 0;
    this.state = {
      errors: {},
      dsProgCalc:
        this.props.item && this.props.item.kpi_data_progress == "1" ? 1 : 0,
      dsMetric:
        this.props.mitChildKr && this.props.item && this.props.item.counting != null
          ? parseInt(this.props.item.counting)
          : this.props.mitChildKr && this.props.counting != null
          ? parseInt(this.props.counting)
          : this.props.item &&
          this.props.item.counting &&
          MIT_DS_METRICS.includes(this.props.item.counting)
          ? parseInt(this.props.item.counting)
          : 1,
      metricDD: false,
      progType:
        this.props.item && this.props.item.progress_type
          ? this.props.item.progress_type
          : 1,
      showProgType: false,
      teamPermissionSelected: this.props.teamPermissionSelected ||
        ((this.props.item && this.props.item.permission_teams)
          ? this.props.item.permission_teams
          : []),
      bizPermissionSelected: this.props.bizPermissionSelected ||
        ((this.props.item && this.props.item.permission_biz)
          ? this.props.item.permission_biz
          : []),
      permissionstate: this.props.permissionstate ||
        ((this.props.item && this.props.item.permission)
          ? this.props.item.permission.split(",").map(Number)
          : this.props.goalDetails.type == 1
            ? [8]
            : [10]),
      permissionHelpPopUp: false,
      dateSegments: this.props.dateSegments ? this.props.dateSegments : [
        {
          startDate: this.props.goalDetails.start_date,
          endDate: moment(this.props.goalDetails.start_date)
            .endOf("month")
            .format("MMM DD, YYYY")
        }
      ],
      target: this.props.target ||
        ((!isStretchEnabled && this.props.item && this.props.item.target) ||
        (isStretchEnabled && this.props.item && this.props.item.stretch_target !== null) ||
        (isStretchEnabled && committedKRFlag && this.props.item && this.props.item.stretch_target == null)
          ? this.props.item.target
          : ((!isStretchEnabled && this.props.basicInlineData && this.props.basicInlineData.target)
          ? this.props.basicInlineData.target
          : ""
        )),
      stretch: this.props.stretch_target ||
        ((this.props.item && this.props.item.stretch_target !== null)
          ? this.props.item.stretch_target
          : isStretchEnabled && this.props.item && this.props.item.target && !committedKRFlag
          ? this.props.item.target
          : isStretchEnabled && this.props.target
          ? this.props.target
          : ''
        ),
      initial_data: this.props.initial_data ||
        ((this.props.item && this.props.item.initial_data)
          ? this.props.item.initial_data
          : ((this.props.basicInlineData && this.props.basicInlineData.initial_data)
            ? this.props.basicInlineData.initial_data
            : 0)),
      krId: this.props.item && this.props.item.id ? this.props.item.id : "",
      startDateError: false,
      dateOverlapError: false,
      quarter_start: this.props.addOkrData.org_quarter_dates,
      confirmPopup: false,
      externalSrc:false,
      titleRetain: "",
      contentRetain: "",
      selectedTypeOpt:this.props.selectedTypeOpt ? this.props.selectedTypeOpt : '',
      krAlingSelected: this.props.krAlingSelected ||
        ((this.props.item && this.props.item.kr_aligns !== undefined && this.props.item.kr_aligns.length > 0)
          ? this.props.item.kr_aligns
          : []),
      krDependenciesSelected: this.props.krDependenciesSelected ||
        ((this.props.item && this.props.item.kr_dependent !== undefined && this.props.item.kr_dependent.length > 0)
          ? this.props.item.kr_dependent
          : []),
      committedKRFlag: this.props.item && this.props.item.committed_target != null ? this.props.item.committed_target :0,
      tags: [],
      exclude: this.props.item && this.props.item.progress_consider == 0 && this.props.item.source == 10 &&
        this.props.kpiType == "ds" ? true : false,
      startingValueErr: false,
      targetValueError: false,
      stretchValueError: false,
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      customInputData:[],
      isCustomSave:[],
      isStretchEnabled: isStretchEnabled,
      milestones: this.props.item?.milestones ?? [],
    };
    this.validateDsKr = this.validateDsKr.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
    this.GoalServices = new GoalServices();
    this.clickEvent = this.clickEvent.bind(this);
    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.setLatVal = this.setLatVal.bind(this);
    this.setMetricDD = this.setMetricDD.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.changeRadioOpt = this.changeRadioOpt.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.renderError = this.renderError.bind(this);
    this.validateDsKrCompleted = this.validateDsKrCompleted.bind(this);
    this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
    this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
    this.krMilestonesSectionRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.kpiRef(this)
    if (!Array.isArray(this.props.item) && this.props.item.id) {
      this._isEdit();
    }
    document.addEventListener("mousedown", this.clickEvent, false);
  }

  componentWillUnmount() {
    this._isMounted = false;
		this.props.kpiRef(null)
    window.removeEventListener("click", this.clickEvent, true);
  }

  _isEdit = () => {
    let { dateSegments } = this.state;
    let { item } = this.props;

    // Check to see if editing a MIT or changing the type from others to MIT
    // The only right way to check for now is to see if child_krs key exists
    if (item && item["child_krs"]) {
      dateSegments = [];
      for (let i = 0; i < item["child_krs"].length; i++) {
        dateSegments.push({
          startDate: moment(item["child_krs"][i]["start_date"]).format(
            "MMM DD, YYYY"
          ),
          endDate: moment(item["child_krs"][i]["end_date"]).format(
            "MMM DD, YYYY"
          ),
          intervalName: item["child_krs"][i]["name"],
          quarterName: item["child_krs"][i]["quarterName"],
          targetValue: item["child_krs"][i]["target"],
          krId: item["child_krs"][i]["id"]
        });
      }
    }
    if(this.props.setDateSegments){
      this.props.setDateSegments(dateSegments);
    }
    this.setState({
      dateSegments: dateSegments,
      isMitEdit: true
    });
  };

  permissionData(perData) {
    this.setState({
      permissionstate: perData
    });
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData
    });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  clickEvent(e) {
    if (this._isMounted) {
      const { showProgType = false, metricDD = false } = this.state;
      if (
        !$(".dsProgTypeDiv").is(e.target) &&
        $(".dsProgTypeDiv").has(e.target).length === 0
        && showProgType
      ) {
        this.setState({
          showProgType: false
        });
      }
      if (
        !$(".dsMetricDdVal").is(e.target) &&
        $(".dsMetricDdVal").has(e.target).length === 0
        && metricDD
      ) {
        this.setState({
          metricDD: false
        });
      }
    }
  }

  handleCancel(){
    this.props.closeKrRightPane(false,this.props.item.id ? this.props.item.id : '')
  }

  getMilestonesPayload() {
    // Ensure milestones is an array before attempting to use array methods
    if (!Array.isArray(this.state.milestones)) {
      return '';
    }
    // milestones need to be an object with keys as index and values as milestone object (for api request)
    const milestones = this.state.milestones
      .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
      .reduce((acc, milestone, index) => ({
        ...acc,
        [index]: {
          id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
          date: milestone.date,
          label: milestone.label,
          target: milestone.target,
        }
      }), {});

    // if there are no milestones, return an empty string (for api request)
    return Object.keys(milestones).length > 0 ? milestones : '';
  }

  handleMilestonesChange(milestones) {
    this.setState({ milestones });
  }

  validateDsKrCompleted(callback = null, data = {}) {
    if (callback && typeof callback === 'undefined') {
      callback(data);
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  validateDsKr(callback = null) {
    let _this = this;
    let errors = {};
    let metricName = this.props.krText;
    let metricNote = this.props.krNote;
    const { t } = this.props;
    _this.isSaveCustom(this.state.customInputData)
    _this.setState({isCustomSave:[]})

    // Check for milestones validation errors
    if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
      toastr.error(t('Milestone dates and values must be within start and target range'));
      return false;
    }

    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
      errors["customokr"] = t(`Please enter required field`);
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
      //setTimeout(() => {
        //this.setState({customFiledRequired:true})
      //   document.querySelector('#cutomobj').scrollIntoView({
      //     behavior: 'smooth',
      //   })
      // }, 200)
    }


    if (this.props.isMit) {
      let initial_data = this.props.initial_data;
      let target = this.props.target;
      let stretch = this.props.stretch;
      let targetLowerVal = this.props.targetLowerVal;
      let targetUpperVal = this.props.targetUpperVal;
      let numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
      //var el = document.getElementById("metric-name-text");
      if (
        typeof metricName === "undefined" ||
        metricName == null ||
        metricName == ""
      ) {
        errors["metricName"] = true;
        //el.classList.add("errorBorder");
        document.getElementById("krNameError").innerHTML =
        t('Please enter key result');
      } else {
        //el.classList.remove("errorBorder");
        document.getElementById("krNameError").innerHTML = "";
      }

      if (typeof initial_data == "" || initial_data === "") {
        errors["showStartErr"] = true;
      } else if (initial_data != "" && !numberWithComma.test(initial_data)) {
        errors["showStartErr"] = true;
        this.setState({
          startValueErr: t("Please enter numeric value.")
        });
      }
      if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
        errors["customokr"] = t(`Please enter required field`);
        this.setState({isCustomSave:this.state.isRequirdCustomOkr})
        setTimeout(() => {
          this.setState({customFiledRequired:true})
          document.querySelector('#cutomobj').scrollIntoView({
            behavior: 'smooth',
          })
        }, 200)
      }
      if (this.state.dsMetric == 4) {
        if (targetLowerVal == "" || targetLowerVal == null) {
          errors["showTargetLowerErr"] = true;
        } else if (
          targetLowerVal != "" &&
          !numberWithComma.test(targetLowerVal)
        ) {
          errors["showTargetLowerErr"] = true;
          this.setState({
            lowerLimitErr: t("Please enter numeric value.")
          });
        }

        if (targetUpperVal == "" || targetUpperVal == null) {
          errors["showTargetUpperErr"] = true;
        } else if (
          targetUpperVal != "" &&
          !numberWithComma.test(targetUpperVal)
        ) {
          errors["showTargetUpperErr"] = true;
          this.setState({
            upperLimitErr: t("Please enter numeric value.")
          });
        }

        if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
          errors["showTargetLowerErr"] = true;
          this.setState({
            lowerLimitErr: t("lower limit is greater than upper limit")
          });
        }
      } else {
        if(this.state.isStretchEnabled) {
          if ((target == "" || target == null) && (stretch == "" || stretch == null)) {
            errors["showTargetErr"] = true;
            errors["showStretchErr"] = true;
          }
        }else {
          if (target == "" || target == null) {
            errors["showTargetErr"] = true;
          }
        }
        if (target != "" && !numberWithComma.test(target)) {
          errors["showTargetErr"] = true;
          this.setState({
            targetValueErr: t("Please enter numeric value.")
          });
        }

        if (
          (!this.state.isStretchEnabled &&
          this.state.dsMetric == 1 &&
          parseFloat(initial_data) > parseFloat(target)) ||
          (this.state.isStretchEnabled &&
          this.state.dsMetric == 1 &&
          (parseFloat(initial_data) > parseFloat(target) || parseFloat(initial_data) > parseFloat(stretch)))
        ) {
          errors["showStartErr"] = true;
          this.setState({
            startValueErr: t("Starting value should be less than target")
          });
        } else if (
          (!this.state.isStretchEnabled &&
          this.state.dsMetric == 2 &&
          parseFloat(initial_data) < parseFloat(target)) ||
          (this.state.isStretchEnabled &&
          this.state.dsMetric == 2 &&
          (parseFloat(initial_data) < parseFloat(target) || parseFloat(initial_data) < parseFloat(stretch)))
        ) {
          errors["showStartErr"] = true;
          this.setState({
            startValueErr: t("Starting value should be greater than target")
          });
        }
        if (
          (target != "" && numberWithComma.test(target)) &&
          (stretch != "" && numberWithComma.test(stretch))
        ) {
          if (
            (this.state.dsMetric == 1 || this.state.dsMetric == 9) &&
            parseFloat(target) > parseFloat(stretch)
          ) {
              errors["showStretchErr"] = t("Stretch target should be greater than committed");

              this.setState({
                stretchValueErr: false
              }, () => {
                this.setState({ stretchValueErr: true })
                this.dsStretch.querySelector('input').focus()
              })
          }
          if (
            (this.state.dsMetric == 2 || this.state.dsMetric == 8) &&
            parseFloat(stretch) > parseFloat(target)
          ) {
              errors["showStretchErr"] = t("Stretch target should be less than committed");

              this.setState({
                stretchValueErr: false
              }, () => {
                this.setState({ stretchValueErr: true })
                this.dsStretch.querySelector('input').focus()
              })
          }
       }
      }

      let error = this._isValidDate();

      if (error["startError"]) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 500 });
        return this.setState({
          startDateError: true
        });
      } else if (error["overlapError"]) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 500 });
        return this.setState({
          dateOverlapError: true
        });
      }

      if (Object.keys(errors).length) {
        this.setState({ errors });
        this.props.setErrors(errors)
        if (errors.metricName) {
          $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
        }
      } else {
        reactLoader(true);
        let params = {};
        if (this.state.dsMetric == 4) {
          params.lower_limit = this.props.targetLowerVal;
          params.upper_limit = this.props.targetUpperVal;
          params.progress_type = 1;
        } else {
          params.target = this.props.target;
          params.progress_type = this.state.progType;
          if (this.state.isStretchEnabled) {
            params.stretchTarget = stretchVal;
          }
        }
        params.name = metricName;
        params.description = metricNote;
        // params.owner = this.props.owner.id;
        params.real_owner = this.props.realOwner.id;
        let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
        params.coOwners = coOwners.length > 0 ? Array.prototype.map
         .call(coOwners, s => s.id)
         .toString() : '';
        params.metric = this.props.measureType;
        params.initial_data = this.props.initial_data;
        params.counting = this.state.dsMetric;
        params.interval = this.props.intervalType;

        params.source = 13;
        params.retainUpdates = this.state.selectedTypeOpt ? this.state.selectedTypeOpt : '' ;
        params.progress_consider = this.props.Exclude ? 0 : 1;
        // params.dsIds = [this.props.dsListSel[0].id];

        params.dataStreamId = this.props.dsListSel[0].id;
        params.interval = this.props.dsListSel[0].frequency;
        params.metric = this.props.dsListSel[0].data_type;
        params.customField = JSON.stringify(this.props.customFieldsData);

        params.isQuarter  =this.props.isQuarter;
        params.kr_duration =this.props.kr_duration;

        if (params.interval == 2) {
          params.weekly_update_day = this.state.dayType;
        }

        let teaMperArr = [], bizPerArr = [];
        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
          if (Array.isArray(permission_teams) && permission_teams.length) {
            teaMperArr = permission_teams.map(val => val.id);
          }
          if (Array.isArray(permission_biz) && permission_biz.length) {
            bizPerArr = permission_biz.map(val => val.id);
          }
        } else {
          if (
            this.state.teamPermissionSelected &&
            this.state.teamPermissionSelected.length > 0
          ) {
            teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
          }
          if (
            this.state.bizPermissionSelected &&
            this.state.bizPermissionSelected.length > 0
          ) {
            bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
          }
        }
        params.permission_teams = teaMperArr;
        params.permission_biz = bizPerArr;

        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          params.permission = this.props.goalDetails.permission;
        } else {
          params.permission = Array.prototype.map
            .call(this.state.permissionstate, s => s)
            .toString(); // "A,B,C";
        }

        let goalId = this.props.goalDetails.id;
        if (this.props.item && this.props.item.id) {
          params.id = this.props.item.id;
        }
        if (!this.state.isStretchEnabled || this.state.dsMetric == 4) {
          params.committed_target = this.state.committedKRFlag == 1 ?1 : 0;
        }
        let { actions } = this.props;
        params["child_krs"] = [];
        let child_krs = $(".mit-interval-targets .w100");
        // Get the list of all the child kr's with the corresponding start and end dates
        for (let i = 0; i < child_krs.length; i++) {
          //{"start_date":"5/28/2019","end_date":"5/29/2019","name":"child MIT  1 1 ","target":"101"}
          let obj = {};
          let startVal = this.state.dateSegments[i].startDate;
          let endVal = this.state.dateSegments[i].endDate;

          // let startVal = $(child_krs[i])
          //   .find("input[name='goal_start_date']")
          //   .val();
          if (!moment(startVal).isValid()) {
            $(child_krs[i])
              .find(".aEStartDate .DayPickerInput")
              .addClass("errorBorder");
            $(child_krs[i])
              .find(".invalid-start-date-error")
              .show();
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          }
          // let endVal = $(child_krs[i])
          //   .find("input[name='goal_end_date']")
          //   .val();
          if (!moment(endVal).isValid()) {
            $(child_krs[i])
              .find(".aEEndDate .DayPickerInput")
              .addClass("errorBorder");
            $(child_krs[i])
              .find(".invalid-end-date-error")
              .show();
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          }
          let name = $(child_krs[i])
            .find("input[name='intervalName']")
            .val();
          let target = $(child_krs[i])
            .find("input[name='targetValue']")
            .val();
          let krId = $(child_krs[i])
            .find(".child-kr-id")
            .data("child-kr-id");
          if (name.trim() === "") {
            $(child_krs[i])
              .find("input[name='intervalName']")
              .addClass("errorBorder");
            $(child_krs[i])
              .find(".name-error")
              .show();
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          } else if (target.trim() === "") {
            $(child_krs[i])
              .find("input[name='targetValue']")
              .addClass("errorBorder");
            $(child_krs[i])
              .find(".target-error")
              .show();
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          } else if (startVal.trim() === "") {
            $(child_krs[i])
              .find("input[name='goal_start_date']")
              .addClass("errorBorder");
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          } else if (endVal.trim() === "") {
            $(child_krs[i])
              .find("input[name='goal_end_date']")
              .addClass("errorBorder");
            removeReactLoader();
            $('.krRightPaneContent').parent().animate({ scrollTop: 300 });
            return;
          }
          obj["start_date"] = moment(startVal).format("MM/DD/YYYY");
          obj["end_date"] = moment(endVal).format("MM/DD/YYYY");
          obj["name"] = name;
          obj["target"] = target;
          if (krId !== "") {
            obj["id"] = krId;
          }
          params["child_krs"][i] = obj;

          let krAlignSel = this.state.krAlingSelected;
          let dependentKrsSel = this.state.krDependenciesSelected;
          let krAligns = [];
          let dependentKrs = [];

          if (krAlignSel && Object.keys(krAlignSel).length > 0) {
            krAlignSel.map(item => {
              krAligns.push(item.id);
            });
          }

          if (dependentKrsSel && Object.keys(dependentKrsSel).length > 0) {
            dependentKrsSel.map(item => {
              dependentKrs.push(item.id);
            });
          }
          params.krAligns = krAligns;
          let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
          let tagids=this.state.tags.length ? this.state.tags : ['']
          let finalTagsIds = [...nlpIds,...tagids]
          params.krTagIds = finalTagsIds;
          params.dependentKr = dependentKrs;
        }
        params.quarter_target_type = this.props.quarterTargetType;
        this.GoalServices.addEditKr({
          goalId: goalId,
          metric: params,
          dontStringify: true
        }).then(response => {
          removeReactLoader();
          if (response.data) {
            if (!this.props.onlyMetEdit) {
              let result = response.data.data;
              let krWeightage = null;
              if (result.krWeightage) {
                krWeightage = result.krWeightage;
                delete result["krWeightage"];
              }
              //console.log("response.data->", response.data.data);
              if (this.state.krId != "") {
                //console.log(this.state.krId);
                actions.editNewKr(this.state.krId, result);
              } else {
                actions.addNewKr(result);
              }
              if (krWeightage) {
                this.props.MetricChangeWeight(krWeightage);
              }
            }
            this.validateDsKrCompleted(callback, response.data.data);
            // this.props.closeKrRightPane(true);
            // this.GoalServices.triggerGoalMetricDetails({ goalId });
          }
        });
      }
    }
    else {
      if (
        typeof metricName === "undefined" ||
        metricName == null ||
        metricName == ""
      ) {
        errors["metricName"] = true;
        this.props.showMetricNameErr();
      }
      var numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
      let targetLowerVal, targetUpperVal, targetVal, startVal, stretchVal;
      if (this.state.dsProgCalc == 0) {
        startVal = this.dsStart.querySelector('input').value
        if (startVal == "" || startVal == null) {
          errors["showStartErr"] = t("Add Value");

          this.setState({
            startingValueErr: false
          }, () => {
            this.setState({ startingValueErr: true })
            this.dsStart.querySelector('input').focus()
          })
        } else if (startVal != "" && !numberWithComma.test(startVal)) {
          errors["showStartErr"] = t("Please enter numeric value");

          this.setState({
            startingValueErr: false
          }, () => {
            this.setState({ startingValueErr: true })
            this.dsStart.querySelector('input').focus()
          })
        }
        if (this.state.dsMetric == 4) {
          targetLowerVal = this.dsTargetLower.value;
          targetUpperVal = this.dsTargetUpper.value;
          if (targetLowerVal == "" || targetLowerVal == null) {
            errors["showTargetLowerErr"] = t("Add Value");
          } else if (
            targetLowerVal != "" &&
            !numberWithComma.test(targetLowerVal)
          ) {
            errors["showTargetLowerErr"] = t("Please enter numeric value");
          }

          if (targetUpperVal == "" || targetUpperVal == null) {
            errors["showTargetUpperErr"] = t("Add Value");
          } else if (
            targetUpperVal != "" &&
            !numberWithComma.test(targetUpperVal)
          ) {
            errors["showTargetUpperErr"] = t("Please enter numeric value");
          }

          if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
            errors["showTargetLowerErr"] =
              t("Lower limit is greater than upper limit");
          }
        } else {
          targetVal = this.dsTarget.querySelector("input").value;
          if(this.state.isStretchEnabled) {
            stretchVal = this.dsStretch.querySelector("input").value ?? '';
            if (
                (targetVal == "" || targetVal == null) &&
                (stretchVal == "" || stretchVal == null)
             ) {
              errors["showTargetErr"] = t("Add Value");
              errors["showStretchErr"] = t("Add Value");
              this.setState({
                targetValueError: false,
                stretchValueError: false
              }, () => {
                this.setState({ targetValueError: true, stretchValueError: true  })
                this.dsStretch.querySelector('input').focus()
              })
            }
            if (stretchVal != "" && !numberWithComma.test(stretchVal)) {
              errors["showTargetErr"] = t("Please enter numeric value.");

              this.setState({
                stretchValueError: false
              }, () => {
                this.setState({ stretchValueError: true })
                this.dsStretch.querySelector('input').focus()
              })
            }
          } else {
            if (targetVal == "" || targetVal == null) {
              errors["showTargetErr"] = t("Add Value");
              this.setState({
                targetValueError: false
              }, () => {
                this.setState({ targetValueError: true })
                this.dsTarget.querySelector('input').focus()
              })
            }
          }
          if (targetVal != "" && !numberWithComma.test(targetVal)) {
            errors["showTargetErr"] = t("Please enter numeric value.");

            this.setState({
              targetValueError: false
            }, () => {
              this.setState({ targetValueError: true })
              this.dsTarget.querySelector('input').focus()
            })
          }
          if (
              (targetVal != "" && numberWithComma.test(targetVal)) &&
              (stretchVal != "" && numberWithComma.test(stretchVal))
            ) {
              if (
                (this.state.dsMetric == 1 || this.state.dsMetric == 9) &&
                parseFloat(targetVal) > parseFloat(stretchVal)
              ) {
                  errors["showStretchErr"] = t("Stretch target should be greater than committed");

                  this.setState({
                    stretchValueErr: false
                  }, () => {
                    this.setState({ stretchValueErr: true })
                    this.dsStretch.querySelector('input').focus()
                  })
              }
              if (
                (this.state.dsMetric == 2 || this.state.dsMetric == 8) &&
                parseFloat(stretchVal) > parseFloat(targetVal)
              ) {
                  errors["showStretchErr"] = t("Stretch target should be less than committed");

                  this.setState({
                    stretchValueErr: false
                  }, () => {
                    this.setState({ stretchValueErr: true })
                    this.dsStretch.querySelector('input').focus()
                  })
              }
           }
          if (
            (!this.state.isStretchEnabled &&
            this.state.dsMetric == 1 &&
            parseFloat(startVal) > parseFloat(targetVal)) ||
            (this.state.isStretchEnabled &&
            this.state.dsMetric == 1 &&
            (parseFloat(startVal) > parseFloat(targetVal) || parseFloat(startVal) > parseFloat(stretchVal)))
          ) {
            errors["showStartErr"] = t("Starting value should be less than target");

            this.setState({
              startingValueErr: false
            }, () => {
              this.setState({ startingValueErr: true })
              this.dsStart.querySelector('input').focus()
            })
          } else if (
            (!this.state.isStretchEnabled &&
            this.state.dsMetric == 2 &&
            parseFloat(startVal) < parseFloat(targetVal)) ||
            (this.state.isStretchEnabled &&
            this.state.dsMetric == 2 &&
            (parseFloat(startVal) < parseFloat(targetVal) || parseFloat(startVal) < parseFloat(stretchVal)))
          ) {
            errors["showStartErr"] =
              t("Starting value should be greater than target");

            this.setState({
              startingValueErr: false
            }, () => {
              this.setState({ startingValueErr: true })
              this.dsStart.querySelector('input').focus()
            })
          }
        }
      }
      if (Object.keys(errors).length) {
        this.setState({ errors });
        if (errors.metricName) {
          $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
        } else if (
          (errors.showTargetErr && errors.showTargetErr.length > 0) ||
          (errors.showTargetUpperErr && errors.showTargetUpperErr.length > 0) ||
          (errors.showTargetLowerErr && errors.showTargetLowerErr.length > 0)
        ) {
          $('.krRightPaneContent').parent().animate({
            scrollTop: $(".krRightPaneContent")[0].scrollHeight - 300
          });
        }
      } else {
        //console.log("source"+this.props.item.source);
        if (this.props.item.source != 1 && this.props.item.source != 10 && this.props.addEditFlag) {
          this.setState({
            confirmPopup: true
          });
        } else {
          let params = {};
          let el = document.getElementById("dsExcludeProg");
          params.progress_consider = el && el.checked ? 0 : 1;
          if (this.state.dsProgCalc == 0) {
            params.initial_data = startVal;
            if (this.state.dsMetric == 4) {
              params.lower_limit = targetLowerVal;
              params.upper_limit = targetUpperVal;
            } else {
              params.target = targetVal;
              if (this.state.isStretchEnabled) {
                params.stretchTarget = stretchVal;
              }
            }
          }
          if (this.props.item && this.props.item.id) {
            params.id = this.props.item.id;
          }
          params.name = metricName;
          params.description = metricNote;
          params.source = "10";
          params.retainUpdates = this.state.selectedTypeOpt ? this.state.selectedTypeOpt : '' ;
          params.real_owner = this.props.realOwner.id;
          let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			    params.coOwners = coOwners.length > 0 ? Array.prototype.map
			     .call(coOwners, s => s.id)
			     .toString() : '';
          params.counting = this.state.dsMetric;
          if (this.state.dsProgCalc == 1) {
            params.kpi_data_progress = this.state.dsProgCalc;
          }
          params.progress_type = this.state.progType;
          params.interval = this.props.dsListSel[0].frequency;
          params.metric = this.props.dsListSel[0].data_type;
          params.dsIds = [this.props.dsListSel[0].id];
          let goalId = this.props.goalDetails.id;
          let { actions } = this.props;

          let teaMperArr = [], bizPerArr = [];
          if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
            const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
            if (Array.isArray(permission_teams) && permission_teams.length) {
              teaMperArr = permission_teams.map(val => val.id);
            }
            if (Array.isArray(permission_biz) && permission_biz.length) {
              bizPerArr = permission_biz.map(val => val.id);
            }
          } else {
            if (
              this.state.teamPermissionSelected &&
              this.state.teamPermissionSelected.length > 0
            ) {
              teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
            }
            if (
              this.state.bizPermissionSelected &&
              this.state.bizPermissionSelected.length > 0
            ) {
              bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
            }
          }
          params.permission_teams = teaMperArr;
          params.permission_biz = bizPerArr;

          if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
            params.permission = this.props.goalDetails.permission;
          } else {
            params.permission = Array.prototype.map
              .call(this.state.permissionstate, s => s)
              .toString(); // "A,B,C";
          }

          let krAlignSel = this.state.krAlingSelected;
          let dependentKrsSel = this.state.krDependenciesSelected;
          let krAligns = [];
          let dependentKrs = [];

          if (krAlignSel && Object.keys(krAlignSel).length > 0) {
            krAlignSel.map(item => {
              krAligns.push(item.id);
            });
          }

          if (dependentKrsSel && Object.keys(dependentKrsSel).length > 0) {
            dependentKrsSel.map(item => {
              dependentKrs.push(item.id);
            });
          }
          params["nested_krs"] = constructNestedKRPayload(this.props);
          params.krAligns = krAligns;
          let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
          let tagids=this.state.tags.length ? this.state.tags : ['']
          let finalTagsIds = [...nlpIds,...tagids]
          params.krTagIds = finalTagsIds;
          params.dependentKr = dependentKrs;
          // Include milestones data if available
          params.milestones = this.getMilestonesPayload();
          params.committed_target = this.state.committedKRFlag == 1 ? 1 : 0;
          if(this.props.isChildKr && this.props.fromParentKr){
            params.duration = this.props.childKrDuration;
            params.selectedDs = this.props.dsListSel;
            params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
            params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
            params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
            if(this.props.item.parent){
              params.parent = this.props.item.parent;
            }
            this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
          } else if(this.props.mitChildKr){
            params.counting = this.props.item?.counting ?? this.props.counting ?? this.state.dsMetric;
						params.duration = this.props.childKrDuration;
            params.selectedDs = this.props.dsListSel;
						params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
						params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
						params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
            params.end_date = this.props.item.end_date;
            params.start_date = this.props.item.start_date;
						this.props.saveQuarterlyKR(params, this.props.mitIndex);
						this.props.closeKrRightPane();
					} else{
            if(this.props.item.parent){
              params.start_date = this.props.childKrDuration.start ;
              params.end_date = this.props.childKrDuration.end;
              params.parent = this.props.item.parent;
            }

            params.isQuarter  =this.props.isQuarter;
            params.kr_duration =this.props.kr_duration;
            params.customField = JSON.stringify(this.props.customFieldsData);
            reactLoader(true);
            this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
              response => {
                removeReactLoader();
                if (response.data) {
                  if (!this.props.onlyMetEdit) {
                    let result = response.data.data;
                    let krWeightage = null;
                    if (result.krWeightage) {
                      krWeightage = result.krWeightage;
                      delete result["krWeightage"];
                    }
                    if(result.parent){
                      actions.addUpdateNestedKr(result)
                    }else{
                      actions.addNewKr(response.data.data);
                    }
                    if (krWeightage) {
                      _this.props.MetricChangeWeight(krWeightage);
                    }
                  }
                  _this.props.closeKrRightPane(true);
                  // this.GoalServices.triggerGoalMetricDetails({ goalId });
                }
              }
            );
          }
        }
      }
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false, externalSrc:false });
  }

  saveItems() {
    const { t } = this.props
    let _this = this;
    let errors = {};
    //let metricName = $("#metric-name-text").val();
    let metricName = this.props.krText;
    //let metricNote = $("#metric-name-note").val();
    let metricNote = this.props.krNote;
    if (
      typeof metricName === "undefined" ||
      metricName == null ||
      metricName == ""
    ) {
      errors["metricName"] = true;
      this.props.showMetricNameErr();
    }
    var numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
    let targetLowerVal, targetUpperVal, targetVal, startVal, stretchVal;
    if (this.state.dsProgCalc == 0) {
      startVal = this.dsStart.querySelector('input').value;
      if (startVal == "" || startVal == null) {
        errors["showStartErr"] = t("Add Value");

        this.setState({
          startingValueErr: false
        }, () => {
          this.setState({ startingValueErr: true })
          this.dsStart.querySelector('input').focus()
        })
      } else if (startVal != "" && !numberWithComma.test(startVal)) {
        errors["showStartErr"] = t("Please enter numeric value");

        this.setState({
          startingValueErr: false
        }, () => {
          this.setState({ startingValueErr: true })
          this.dsStart.querySelector('input').focus()
        })
      }
      if (this.state.dsMetric == 4) {
        targetLowerVal = this.dsTargetLower.value;
        targetUpperVal = this.dsTargetUpper.value;
        if (targetLowerVal == "" || targetLowerVal == null) {
          errors["showTargetLowerErr"] = t("Add Value");
        } else if (
          targetLowerVal != "" &&
          !numberWithComma.test(targetLowerVal)
        ) {
          errors["showTargetLowerErr"] = t("Please enter numeric value");
        }

        if (targetUpperVal == "" || targetUpperVal == null) {
          errors["showTargetUpperErr"] = t("Add Value");
        } else if (
          targetUpperVal != "" &&
          !numberWithComma.test(targetUpperVal)
        ) {
          errors["showTargetUpperErr"] = t("Please enter numeric value");
        }

        if (parseFloat(targetLowerVal) > parseFloat(targetUpperVal)) {
          errors["showTargetLowerErr"] =
            t("Lower limit is greater than upper limit");
        }
      } else {
        targetVal = this.dsTarget.querySelector('input').value;
        if(this.state.isStretchEnabled) {
          stretchVal = this.dsStretch.querySelector("input").value;
          if ((targetVal == "" || targetVal == null) && (stretchVal == "" || stretchVal == null)) {
            errors["showTargetErr"] = t("Add Value");
            errors["showStretchErr"] = t("Add Value");
            this.setState({
              targetValueError: false,
              stretchValueError: false
            }, () => {
              this.setState({ targetValueError: true, stretchValueError: true  })
              this.dsStretch.querySelector('input').focus()
            })
          }
          if (stretchVal != "" && !numberWithComma.test(stretchVal)) {
            errors["showTargetErr"] = t("Please enter numeric value.");

            this.setState({
              stretchValueError: false
            }, () => {
              this.setState({ stretchValueError: true })
              this.dsStretch.querySelector('input').focus()
            })
          }
        } else {
          if (targetVal == "" || targetVal == null) {
            errors["showTargetErr"] = t("Add Value");

            this.setState({
              targetValueError: false
            }, () => {
              this.setState({ targetValueError: true })
              this.dsTarget.querySelector('input').focus()
            })
          }
        }
        if (targetVal != "" && !numberWithComma.test(targetVal)) {
          errors["showTargetErr"] = t("Please enter numeric value.");

          this.setState({
            targetValueError: false
          }, () => {
            this.setState({ targetValueError: true })
            this.dsTarget.querySelector('input').focus()
          })
        }
        if (
          (!this.state.isStretchEnabled &&
          this.state.dsMetric == 1 &&
          parseFloat(startVal) > parseFloat(targetVal)) ||
          (this.state.isStretchEnabled &&
          this.state.dsMetric == 1 &&
          (parseFloat(startVal) > parseFloat(targetVal) || parseFloat(startVal) > parseFloat(stretchVal)))
        ) {
          errors["showStartErr"] = t("Starting value should be less than target");

          this.setState({
            startingValueErr: false
          }, () => {
            this.setState({ startingValueErr: true })
            this.dsStart.querySelector('input').focus()
          })
        } else if (
          (!this.state.isStretchEnabled &&
          this.state.dsMetric == 2 &&
          parseFloat(startVal) < parseFloat(targetVal)) ||
          (this.state.isStretchEnabled &&
          this.state.dsMetric == 2 &&
          (parseFloat(startVal) < parseFloat(targetVal) || parseFloat(startVal) < parseFloat(stretchVal)))
        ) {
          errors["showStartErr"] =
            t("Starting value should be greater than target");

          this.setState({
            startingValueErr: false
          }, () => {
            this.setState({ startingValueErr: true })
            this.dsStart.querySelector('input').focus()
          })
        }
        if (
          (targetVal != "" && numberWithComma.test(targetVal)) &&
          (stretchVal != "" && numberWithComma.test(stretchVal))
        ) {
          if (
            (this.state.dsMetric == 1 || this.state.dsMetric == 9) &&
            parseFloat(targetVal) > parseFloat(stretchVal)
          ) {
              errors["showStretchErr"] = t("Stretch target should be greater than committed");

              this.setState({
                stretchValueErr: false
              }, () => {
                this.setState({ stretchValueErr: true })
                this.dsStretch.querySelector('input').focus()
              })
          }
          if (
            (this.state.dsMetric == 2 || this.state.dsMetric == 8) &&
            parseFloat(stretchVal) > parseFloat(targetVal)
          ) {
              errors["showStretchErr"] = t("Stretch target should be less than committed");

              this.setState({
                stretchValueErr: false
              }, () => {
                this.setState({ stretchValueErr: true })
                this.dsStretch.querySelector('input').focus()
              })
          }
       }
      }
    }
    if (Object.keys(errors).length) {
      this.setState({ errors });
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      } else if (
        (errors.showTargetErr && errors.showTargetErr.length > 0) ||
        (errors.showTargetUpperErr && errors.showTargetUpperErr.length > 0) ||
        (errors.showTargetLowerErr && errors.showTargetLowerErr.length > 0)
      ) {
        $('.krRightPaneContent').parent().animate({
          scrollTop: $(".krRightPaneContent")[0].scrollHeight - 300
        });
      }
    } else {
      let params = {};
      let el = document.getElementById("dsExcludeProg");
      params.progress_consider = el && el.checked ? 0 : 1;
      if (this.state.dsProgCalc == 0) {
        params.initial_data = startVal;
        if (this.state.dsMetric == 4) {
          params.lower_limit = targetLowerVal;
          params.upper_limit = targetUpperVal;
        } else {
          params.target = targetVal;
          if (this.state.isStretchEnabled) {
            params.stretchTarget = stretchVal;
          }
        }
      }
      if (this.props.item && this.props.item.id) {
        params.id = this.props.item.id;
      }
      params.name = metricName;
      params.description = metricNote;
      params.source = "10";
      params.retainUpdates = this.state.selectedTypeOpt ? this.state.selectedTypeOpt : '' ;
      params.real_owner =this.props.realOwner.id;
      let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
       .call(coOwners, s => s.id)
       .toString() : '';
      params.counting = this.state.dsMetric;
      if (this.state.dsProgCalc == 1) {
        params.kpi_data_progress = this.state.dsProgCalc;
      }
      params.progress_type = this.state.progType;
      params.interval = this.props.dsListSel[0].frequency;
      params.metric = this.props.dsListSel[0].data_type;
      params.dsIds = [this.props.dsListSel[0].id];
      params.quarter_target_type = this.props.quarterTargetType;
      let goalId = this.props.goalDetails.id;
      let { actions } = this.props;

      let teaMperArr = [], bizPerArr = [];
      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
        if (Array.isArray(permission_teams) && permission_teams.length) {
          teaMperArr = permission_teams.map(val => val.id);
        }
        if (Array.isArray(permission_biz) && permission_biz.length) {
          bizPerArr = permission_biz.map(val => val.id);
        }
      } else {
        if (
          this.state.teamPermissionSelected &&
          this.state.teamPermissionSelected.length > 0
        ) {
          teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
        }
        if (
          this.state.bizPermissionSelected &&
          this.state.bizPermissionSelected.length > 0
        ) {
          bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
        }
      }
      params.permission_teams = teaMperArr;
      params.permission_biz = bizPerArr;

      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        params.permission = this.props.goalDetails.permission;
      } else {
        params.permission = Array.prototype.map
          .call(this.state.permissionstate, s => s)
          .toString(); // "A,B,C";
      }
      let krAlignSel = this.state.krAlingSelected;
      let dependentKrsSel = this.state.krDependenciesSelected;
      let krAligns = [];
      let dependentKrs = [];

      if (krAlignSel && Object.keys(krAlignSel).length > 0) {
        krAlignSel.map(item => {
          krAligns.push(item.id);
        });
      }

      if (dependentKrsSel && Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map(item => {
          dependentKrs.push(item.id);
        });
      }
      params["nested_krs"] = constructNestedKRPayload(this.props);
      params.krAligns = krAligns;
      let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids=this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds,...tagids]
      params.krTagIds = finalTagsIds;
      params.dependentKr = dependentKrs;
      // Include milestones data if available
      params.milestones = this.getMilestonesPayload();
      params.customField = JSON.stringify(this.props.customFieldsData);
       if(this.props.isChildKr && this.props.fromParentKr){
          params.duration = this.props.childKrDuration;
          params.selectedDs = this.props.dsListSel;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
          if(this.props.item.parent){
            params.parent = this.props.item.parent;
          }
          this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
        } else if(this.props.mitChildKr){
          params.counting = this.props.item?.counting ?? this.props.counting ?? this.state.dsMetric;
          params.duration = this.props.childKrDuration;
          params.selectedDs = this.props.dsListSel;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.end_date = this.props.item.end_date;
          params.start_date = this.props.item.start_date;
          this.props.saveQuarterlyKR(params, this.props.mitIndex);
          this.props.closeKrRightPane();
        } else{
          if(this.props.item.parent){
            params.start_date = this.props.childKrDuration.start ;
            params.end_date = this.props.childKrDuration.end;
            params.parent = this.props.item.parent;
          }

          params.isQuarter  =this.props.isQuarter;
          params.kr_duration =this.props.kr_duration;
          params.customField = JSON.stringify(this.props.customFieldsData);
          reactLoader(true);
          this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
            response => {
              removeReactLoader();
              if (response.data) {
                if (!this.props.onlyMetEdit) {
                  let result = response.data.data;
                  let krWeightage = null;
                  if (result.krWeightage) {
                    krWeightage = result.krWeightage;
                    delete result["krWeightage"];
                  }
                  if(result.parent){
                    actions.addUpdateNestedKr(result)
                  }else{
                    actions.addNewKr(response.data.data);
                  }
                  if (krWeightage) {
                    _this.props.MetricChangeWeight(krWeightage);
                  }
                }
                _this.props.closeKrRightPane(true);
                // this.GoalServices.triggerGoalMetricDetails({ goalId });
              }
            }
          );
        }
    }
  }
  changeRadioOpt(value) {
    const valueToSet = value
		this.setState(
		  {
        selectedTypeOpt: valueToSet
		  }
		)
	}
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }
  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
            }
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }

      }
      const tempData=finalDataArray
    })

  }

  isRequiredCustomOkrFiled(isVal,id){
    let cust_id=this.state.isCustomSave.find((u) => u == id);
    let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
    let fr= ar.filter(
        (u) => u != cust_id
      )
    this.setState({isCustomSave:fr})
    this.isSaveCustom(isVal)
    this.setState({customInputData:isVal})
  }

  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }


  resetErrorMsg(msgText) {
    this.setState({
      errors: {
        ...this.state.filter,
        [`$(msgText)`]: []
      }
    });
  }

  setMetricDD() {
    this.setState({ metricDD: !this.state.metricDD });
    $('.krRightPaneContent').parent().animate({ scrollTop: 430 });
  }

  setLatVal() {
    this.setState({ showProgType: !this.state.showProgType });
    $('.krRightPaneContent').parent().animate({ scrollTop: 430 });
  }

  /**
   * Validates endDate of child KR is always greater than start date and there is no overlap
   * @param startDate
   * @param endDate
   * @private
   */
  _isValidDate = () => {
    let { dateSegments } = this.state;
    let shallowCopyDateSegments = [].concat(dateSegments);
    let dLength = shallowCopyDateSegments.length;
    // Sorting all my date values by start date and then checking to make sure end date is always > than start date
    let sortedDateSegments = shallowCopyDateSegments.sort((a, b) => {
      return new Date(a.startDate).valueOf() - new Date(b.startDate).valueOf();
    });
    if (dLength === 1) {
      if (
        !moment(sortedDateSegments[0]["startDate"]).isBefore(
          sortedDateSegments[0]["endDate"]
        )
      ) {
        return { startError: true };
      }
    }
    for (let i = 1; i < dLength; i++) {
      if (
        !moment(sortedDateSegments[i - 1]["startDate"]).isBefore(
          sortedDateSegments[i - 1]["endDate"]
        )
      ) {
        return { startError: true };
      }
      if (
        sortedDateSegments[i]["startDate"] === "" ||
        sortedDateSegments[i - 1]["endDate"] === ""
      ) {
        continue;
      }
      if (
        !moment(sortedDateSegments[i]["startDate"]).isAfter(
          sortedDateSegments[i - 1]["endDate"]
        ) ||
        !moment(sortedDateSegments[i]["endDate"]).isAfter(
          sortedDateSegments[i]["startDate"]
        )
      ) {
        return { overlapError: true };
      }
    }
    return { noError: true };
  };

  saveAlignArr(alignData) {
    this.setState({
      krAlingSelected: alignData
    })
  }
  saveDependentArr(dependentData) {
    this.setState({
      krDependenciesSelected: dependentData
    })
  }
  handleCommittedKRChange = () => {
    this.setState({
      committedKRFlag: this.state.committedKRFlag == 1 ? 0 : 1
    });
  }
  saveTag = (childData) =>{
    this.setState({tags:childData})
  }
  handleExcludeChange = () =>{
    this.setState({
      exclude: !this.state.exclude,
    })
  }
  render() {
    const { t } = this.props
    let dsListSel = this.props.dsListSel;
    let errors = this.state.errors;
    let isErrors = Object.keys(errors).length;
    let dsProg = [
      {
        value: 1,
        name : t("Last Entered Value"),
      },
      {
        value: 2,
        name : t("Total of all entered values")
      },
      {
        value: 3,
        name : t("Average of all entered values")
      }
    ];
    const { exclude, targetValueError, stretchValueError } = this.state;

    let targetValueHelperText = isErrors && typeof errors["showTargetErr"] !== "undefined" ? errors["showTargetErr"] : ""
    let stretchValueHelperText = isErrors && typeof errors["showStretchErr"] !== "undefined" ? errors["showStretchErr"] : ""

    return (
      <div className="ds_kr">
        <div className="dsTextLabel">{t('Selected data stream')+':'}</div>
        {dsListSel &&
          Object.keys(dsListSel).length > 0 &&
          Object.keys(dsListSel).map((item, index) => (
            <div className="dsListLeftBorder" data-testid="dsListLeftBorder" key={index}>
              <DsComp
                ds={dsListSel[item]}
                showCancel={true}
                removeObjFromList={this.props.removeObjFromList}
              />
            </div>
          ))}

        {!this.props.isMit && (
          <div>
            <div className="dsProgressDiv">
              <StyledRadioGroup
                label={t("How do you want to show progress?")}
                value={this.state.dsProgCalc}
                defaultValue={this.state.dsProgCalc}
              >
                <Radio
                  label={t("Data stream is already a progress percentage")}
                  value={1}
                  isChecked={this.state.dsProgCalc == "0" ? false : true}
                  onChange={() => this.setState({ dsProgCalc: 1 })}
                />
                <Radio
                  label={t("Calculate data stream progress")}
                  value={0}
                  isChecked={this.state.dsProgCalc == "0" ? true : false}
                  onChange={() => this.setState({ dsProgCalc: 0 })}
                />
              </StyledRadioGroup>
            </div>
            {this.state.dsProgCalc == 0 && (
              <div className="dsProgCalcDiv">
                <div
                  className={
                    "basic-flex-box dsCalcDiv " +
                    (isErrors && Object.keys(errors).length > 0
                      ? "pB10 "
                      : ""
                  )}
                >
                  <div className="dsStartVal basic-flex-content">
                    <div className="dsTextLabel" id="starting_value_field">
                      {t('Starting from')}<span className="text-style-1">*</span>
                    </div>
                    <StyledTextfield
                      aria-labelledby="starting_value_field"
                      autoComplete="off"
                      isError={this.state.startingValueErr ? true : false}
                      helperText={isErrors &&
                        typeof errors["showStartErr"] !== "undefined" ? errors["showStartErr"] : ""}
                      isRequired
                      onChange={() => this.resetErrorMsg("showStartErr")}
                      ref={node => (this.dsStart = node)}
                      type="text"
                      defaultValue={
                        this.props.item && this.props.item.initial_data
                          ? this.props.item.initial_data
                          : "0"
                      }
                      className="dsCalcTextfield"
                    />
                  </div>
                  <div className="dsTargetSel basic-flex-content marginR12">
                    <div className="dsTextLabel" style={{ height: "24px", fontSize:"13px" }}>{t('Result value')}
                      <HelpTextComp key="resultvaluehelp">
                        <div style={{ whiteSpace: "pre-wrap" }}>
                          <ul>
                            <li>
                              <b>{t('Should increase to')} </b>
                              {t('example') +':'} {t('Starting from 0 MQLs moving to 10 MQLs')}
                            </li>
                            <li>
                              <b>{t('Should decrease to')} </b>
                              {t('example') +':'} {t('Starting from 100 bugs moving to 10 bugs')}
                            </li>
                            <li>
                              <b>{t('Should be equal to')} </b>
                              {t('example') +':'} {t('When you have an exact number to hit, like hiring exactly 10 developers - not less, not more')}
                            </li>
                            <li>
                              <b>{t('Should fall within a range')} </b>
                              {t('example') +':'} {t('Starting from $0 aiming to move towards a range of $10-$15')}
                            </li>
                          </ul>
                        </div>
                      </HelpTextComp>
                    </div>
                    <StyledDropdown
                      options={getTargetValue()}
                      onChange={(e) => this.setState({ dsMetric:  e.target["value"]}) }
                      id={"result-value-dropdown"}
                      data-testid={"result-value-dropdown"}
                      value={Number(
                        this.props.mitChildKr && this.props.item?.counting != null
                          ? this.props.item.counting
                          : this.props.mitChildKr && this.props.counting != null
                          ? this.props.counting
                          : this.state.dsMetric
                      )}
                      aria-label='Result Value'
                      showStartNodeOnSelect
                      optionTitleProp="name"
                      optionValueProp="value"
                      disabled={!!this.props.mitChildKr}
                      MenuProps={{
                        style: {
                          zIndex: '1500000'
                        }
                      }}
                    />
                  </div>
                  {this.state.dsMetric != 4 ? (
                    <div className="dsTargetVal basic-flex-content">
                      <div className={ !this.state.isStretchEnabled ? "dsTextLabel" : "dsTextLabel target-text-bold"} id="target_value_field">
                        {t('Target value')}<span className="text-style-1">*</span>
                      </div>
                      { this.state.isStretchEnabled &&  this.state.dsMetric != 4 && (
                      <div className="metric-target-text marginB5 widthFitContent">
                          {t('Committed target')}
                        <HelpTextComp popUpClass={this.state.dsMetric == 4 ? "rightAlign" : "leftAlign"} wrapperClass="committedKRHelpText marginL3">
                          {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.') + t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                        </HelpTextComp>
                      </div>
                      )}
                      { !this.state.isStretchEnabled ?
                      (<StyledTextfield
                        aria-labelledby="target_value_field"
                        autoComplete="off"
                        isError={targetValueError}
                        isRequired
                        helperText={targetValueHelperText}
                        onChange={() => this.resetErrorMsg("showTargetErr")}
                        ref={node => (this.dsTarget = node)}
                        type="text"
                        defaultValue={this.state.target}
                        className="dsCalcTextfield"
                      />)
                     : (<StyledTextfield
                      aria-labelledby="target_value_field"
                      autoComplete="off"
                      isError={targetValueError}
                      isRequired
                      helperText={targetValueHelperText}
                      onChange={() => this.resetErrorMsg("showTargetErr")}
                      ref={node => (this.dsTarget = node)}
                      type="text"
                      defaultValue={this.state.target}
                      className="dsCalcTextfield"
                      style={{width:"115px"}}
                    />)}
                    </div>
                  ) : (
                    ""
                  )}
                    {this.state.dsMetric != 4 && this.state.isStretchEnabled ? (
                    <div className="target-input-box">
                      <div className="dsTextLabel" id="target_value_field">
                      </div>
                      <div className="metric-target-text marginB5 widthFitContent">
                        {t('Stretch target')}
                        <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                        {t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                        </HelpTextComp>
                      </div>
                      <StyledTextfield
                        aria-labelledby="stretch_value_field"
                        autoComplete="off"
                        isError={stretchValueError}
                        isRequired
                        helperText={stretchValueHelperText}
                        onChange={() => this.resetErrorMsg("showStretchErr")}
                        ref={node => (this.dsStretch = node)}
                        type="text"
                        defaultValue={this.state.stretch}
                        className="dsCalcTextfield"
                        style={{width:"115px"}}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.dsMetric == 4 ? (
                    <div style={{display: 'flex'}}>
                      <div className="dsTargetVal basic-flex-content">
                        <div className="dsTextLabel">
                          {t('Target lower limit')}
                          <span className="text-style-1">*</span>
                        </div>
                        <div className="dsTargetInpLower" style={{ marginRight: "0px" }}>
                          <input
                            type="text"
                            name="ds_target_lower"
                            className="dsCalcInp"
                            style={{ width: "105px" }}
                            ref={node => (this.dsTargetLower = node)}
                            defaultValue={
                              this.props.item && this.props.item.lower_limit
                                ? this.props.item.lower_limit
                                : ""
                            }
                            onKeyDown={() =>
                              this.resetErrorMsg("showTargetLowerErr")
                            }
                            autoComplete="off"
                          />
                        </div>
                        {isErrors &&
                          typeof errors["showTargetLowerErr"] !== "undefined" ? (
                          <div className="dsErr">
                            {errors["showTargetLowerErr"]}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="dsTargetVal basic-flex-content">
                        <div className="dsTextLabel">
                          {t('Target upper limit')}
                          <span className="text-style-1">*</span>
                        </div>
                        <div className="dsTargetInpHigher">
                          <input
                            type="text"
                            name="ds_target_upper"
                            className="dsCalcInp"
                            style={{ width: "105px" }}
                            ref={node => (this.dsTargetUpper = node)}
                            defaultValue={
                              this.props.item && this.props.item.upper_limit
                                ? this.props.item.upper_limit
                                : ""
                            }
                            onKeyDown={() =>
                              this.resetErrorMsg("showTargetUpperErr")
                            }
                            autoComplete="off"
                          />
                        </div>
                        {isErrors &&
                          typeof errors["showTargetUpperErr"] !== "undefined" ? (
                          <div className="dsErr">
                            {errors["showTargetUpperErr"]}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  { this.state.dsMetric != 4 && this.props.addOkrData.showCommittedTarget && !this.state.isStretchEnabled &&
                    <div className="inLineBlk">
                        <div style={{height: '19px'}}></div>
                        <div className="committedKRWrapper" style={{marginLeft: '0'}}>
                          <StyledCommittedCheckbox
                       	    id="committedKR"
                            label={`Committed ${t('result')}`}
                            onChange={this.handleCommittedKRChange}                            isChecked={this.state.committedKRFlag == 1 ? true : false}
                          />

                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText">
                            {`${t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} ${t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}`}
                          </HelpTextComp>
                        </div>
                    </div>
                  }
                </div>
                <div className="dsShowProgressDiv">
                  <div className="dsTextLabel" style={{height:24}}>
                    {t('Key result progress should be')+':'}
                    <span className="text-style-1">*</span>
                  </div>
                  <StyledDropdown
                    data-testid="CalculateOverDropDown"
                    id="cal-overall-dropdown"
                    aria-labelledby="cal-overall"
                    value={Number(this.state.progType)}
                    autoMenuWidth
                    onChange={(event) => {
                      this.setState({ progType: event.target["value"]});
                    }}
                    optionTitleProp="name"
                    optionValueProp="value"
                    options={dsProg}
                    MenuProps={{
                      style: {
                        zIndex: '1500000'
                      },
                    }}
                  />
                </div>
              </div>
            )}
            {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
            {  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&&
                    <Customokr
                      customData={this.props.customData}
                      isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                      onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                      customFiledRequired={true}
                      renderError={this.renderError}
                      isCustomSave={this.state.isCustomSave}
                    />
            }
            {
              !this.props.isChildKr && !this.props.mitChildKr &&
              <div className="krBreak" aria-hidden="true" />
            }
            {!this.props.isChildKr && !this.props.mitChildKr && (
              <KrMilestonesSection ref={this.krMilestonesSectionRef} source={krdetailConstants.SOURCE_DATA_STREAMS} {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
            )}
            { !this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.validateDsKr} />}
            <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
            {!this.props.isChildKr && !this.props.mitChildKr &&
              <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
                nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
              />
            }
            {
              (this.props.addOkrData.display_nested_kr &&
              !this.props.isChildKr && !this.props.mitChildKr &&
              Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
              <NestedInlineComp
              {...this.props}
              actions = {this.props.actions}
              nested_krs = {this.props.nested_krs}
              updateNestedKrs = {this.props.updateNestedKrs}
              />
            }
            {!this.props.isChildKr && !this.props.mitChildKr &&
              <KrAlignDependance {...this.props}
                saveDependentArr={this.saveDependentArr}
                saveAlignArr={this.saveAlignArr}
                krAlingArr={this.props.item.kr_aligns}
                krDependenciesArr={this.props.item.kr_dependent}
              />
            }
            {!this.props.isChildKr && !this.props.mitChildKr &&
              <div className="dsExcludeDiv">
                <ThemeProvider>
                  <StyledCheckbox
                    id="dsExcludeProg"
                    isChecked={exclude}
                    label={t(`Exclude from objective progress calculation`)}
                    onChange={this.handleExcludeChange}
                  />
                </ThemeProvider>
              </div>
            }


            {this.props.goalDetails && !this.props.mitChildKr &&
              this.props.goalDetails.all_metrics == "0" ? (
              <div className="pT10">
                <div className="viewPermissionArea">
                  <span>
                    {t('View permissions in addition to')}{" "}
                    {this.props.goalDetails.type == 1 ? t(" team ") : t(" owner ")}
                    <div
                      className="metricTargetHelptext permissionHelpText"
                      onMouseEnter={event => {
                        this.setState({ permissionHelpPopUp: true });
                      }}
                      onMouseLeave={event => {
                        this.setState({ permissionHelpPopUp: false });
                      }}
                    />
                    {this.state.permissionHelpPopUp && (
                      <div className="basic-popup">
                        {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                      </div>
                    )}
                  </span>
                </div>
                <div className="pB10">
                  <PermissionComp
                    {...this.props}
                    teamPermissionData={this.teamPermissionData}
                    bizPermissionData={this.bizPermissionData}
                    permissionData={this.permissionData}
                    hide={false}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.confirmPopup && (
              <DeleteCommonModal
                exitDeleteModal={this.exitDeleteModal}
                deleteItems={this.saveItems}
                id=""
                title={t("Save Key Result with New Data Type")}
                deleteContentOne=""
                deleteContentSecondParam=""
                deletefirstTitle=""
                deleteContentSecond={t("Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.")}
                buttonText={t("Save")}
              />
            )}
            {
              this.state.externalSrc  &&
                <RetainUpdateModal
                      selectedType={this.state.selectedTypeOpt}
                      changeRadio={this.changeRadioOpt}
                      exitDeleteModal={this.exitDeleteModal}
                      deleteItems={this.saveItems}
                      titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
                      contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
                    />
            }
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(DataStreamComp);
